import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// PWA service worker
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      // Service worker registration is best-effort; failure is non-fatal.
      if (process.env.NODE_ENV === "development") {
        console.warn("SW registration failed", err);
      }
    });
  });
}

// Capture beforeinstallprompt globally so any page can trigger install
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__xookmedia_install_event = e;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
